// React Query hook for the cross-contract schedule aggregation
// (GET /manage/schedule). Follows the useManagedContracts pattern: a
// single useQuery keyed on the params object, delegating to
// scheduleApi.list (which types the response so the untyped-apiRequest
// Promise<{}> gotcha is avoided). The caller derives from/to from the
// selected period and the CSV filter params from the URL state.

import { useQuery } from "@tanstack/react-query";
import { scheduleApi } from "../services/api";

export interface UseScheduleParams {
  from: string;
  to: string;
  contracts?: string;
  kinds?: string;
  search?: string;
}

export function useSchedule(params: UseScheduleParams) {
  return useQuery({
    queryKey: ["schedule", params],
    queryFn: () => scheduleApi.list(params),
  });
}
